export default __webpack_public_path__ + "static/media/news-05.7f5dbcbd.jpg";